import { Flex } from "@chakra-ui/react";
import WorkingTimeItem from "./WorkingTimeItem/WorkingTimeItem";
import { CalendarModel, ScheduleModel } from "../CreateCalendar/CalendarModel";

interface Props {
  onDataChange: (calendar: CalendarModel) => void;
  calendar: CalendarModel;
}
const WORKING_TIMES = [
  { dayOfWeek: "Monday", isAvailable: false, intervals: [] },
  { dayOfWeek: "Tuesday", isAvailable: false, intervals: [] },
  { dayOfWeek: "Wednesday", isAvailable: false, intervals: [] },
  { dayOfWeek: "Thursday", isAvailable: false, intervals: [] },
  { dayOfWeek: "Friday", isAvailable: false, intervals: [] },
  { dayOfWeek: "Saturday", isAvailable: false, intervals: [] },
  { dayOfWeek: "Sunday", isAvailable: false, intervals: [] },
] as ScheduleModel[];

export default function WorkingTimeContainerCalendar(props: Props) {
  const calendar = props.calendar as CalendarModel;
  const timeMenu: { hours: number; minutes: number }[] = [];
  let minutes = 0;
  const setMenuTime = () => {
    for (let i = 0; i <= 23; ) {
      timeMenu.push({ hours: i, minutes: minutes });
      if (minutes === 45) {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        minutes = 0;
        i++;
      } else {
        minutes = minutes + 15;
      }
    }
  };

  setMenuTime();

  const day = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

  const addTime = (dayTime: string) => {
    let newWorkingTime = calendar.schedule || WORKING_TIMES;

    const findWorkingTime = newWorkingTime.find(el => el.dayOfWeek === dayTime);
    let changeWorkingTime = findWorkingTime ? { ...findWorkingTime } : undefined;

    if (changeWorkingTime && changeWorkingTime.intervals) {
      changeWorkingTime = {
        ...changeWorkingTime,
        isAvailable: true,
        intervals: [...changeWorkingTime.intervals, { beginTime: "10:00", endTime: "18:00" }],
      };
      newWorkingTime = newWorkingTime.filter(el => el.dayOfWeek !== dayTime);
      newWorkingTime = [...newWorkingTime, changeWorkingTime];
    } else {
      newWorkingTime = [
        ...newWorkingTime,
        {
          dayOfWeek: dayTime,
          isAvailable: true,
          intervals: [{ beginTime: "10:00", endTime: "18:00" }],
        },
      ];
    }

    newWorkingTime.sort((a, b) => day.indexOf(a.dayOfWeek) - day.indexOf(b.dayOfWeek));

    props.onDataChange({ ...calendar, schedule: [...newWorkingTime], isAvailable: true } as CalendarModel);
  };

  const removeTime = (dayTime: string, index: number) => {
    let newWorkingTime = calendar.schedule || [];
    const findWorkingTime = newWorkingTime.find(el => el.dayOfWeek === dayTime);
    const changeWorkingTime = findWorkingTime ? { ...findWorkingTime } : undefined;

    if (changeWorkingTime) {
      changeWorkingTime.intervals = changeWorkingTime.intervals.filter((el, i) => i !== index);
      changeWorkingTime.isAvailable = changeWorkingTime.intervals.length > 0;
      newWorkingTime = newWorkingTime.filter(el => el.dayOfWeek !== dayTime);

      newWorkingTime = [...newWorkingTime, changeWorkingTime];
    }

    let isUndefinedTime = true;
    newWorkingTime.forEach(el => {
      if (el.intervals.length !== 0) {
        isUndefinedTime = false;
      }
    });

    newWorkingTime.sort((a, b) => day.indexOf(a.dayOfWeek) - day.indexOf(b.dayOfWeek));

    props.onDataChange({
      ...calendar,
      isAvailable: !isUndefinedTime,
      schedule: isUndefinedTime ? WORKING_TIMES : [...newWorkingTime],
    } as CalendarModel);
  };

  const copyDay = (dayTime: string) => {
    if (calendar.schedule) {
      const newWorkingTime: ScheduleModel[] = [];
      const findWorkingTime = calendar.schedule.find(el => el.dayOfWeek === dayTime);

      if (findWorkingTime) {
        day.forEach((el, i) => {
          newWorkingTime.push({
            dayOfWeek: el,
            intervals: findWorkingTime.intervals,
            isAvailable: true,
          });
        });
      }

      newWorkingTime.sort((a, b) => day.indexOf(a.dayOfWeek) - day.indexOf(b.dayOfWeek));

      props.onDataChange({
        ...calendar,
        schedule: [...newWorkingTime],
      } as CalendarModel);
    }
  };

  const changeTime = (newTime: { beginTime: string; endTime: string }, index: number, dayTime: string) => {
    if (calendar.schedule) {
      const findDay = calendar.schedule.find(el => el.dayOfWeek === dayTime);
      const newWorkingTimes: Array<{ beginTime: string; endTime: string }> = [];

      findDay?.intervals.forEach((el, ind) => {
        if (ind === index) {
          newWorkingTimes.push(newTime);
        } else {
          newWorkingTimes.push(el);
        }
      });
      newWorkingTimes.sort((a, b) => (a.beginTime > b.beginTime ? 1 : -1));

      const changeWorkingTimes: ScheduleModel[] = [];
      calendar.schedule.forEach((el, ind) => {
        if (el.dayOfWeek === dayTime) {
          changeWorkingTimes.push({ dayOfWeek: dayTime, intervals: newWorkingTimes, isAvailable: true });
        } else {
          changeWorkingTimes.push(el);
        }
      });

      changeWorkingTimes.sort((a, b) => day.indexOf(a.dayOfWeek) - day.indexOf(b.dayOfWeek));

      props.onDataChange({
        ...calendar,
        schedule: changeWorkingTimes,
      } as CalendarModel);
    }
  };

  const chooseTime = (dayTime: string) => {
    const times = calendar.schedule || [];

    const result = times.find(el => el.dayOfWeek === dayTime);
    return result ? result.intervals : [];
  };
  const getIntersectionRatio = (dayTime: string) => {
    const times = calendar.schedule || [];
    const result = times.find(el => el.dayOfWeek === dayTime);
    const intersectionByDay = Boolean(
      result?.intervals.some((el, index, arr) => {
        if (index > 0) {
          return el.beginTime < arr[index - 1].endTime;
        } else {
          return false;
        }
      }),
    );
    return intersectionByDay;
  };

  return (
    <Flex maxH="400px" overflow="auto" gap="8px" flexDirection="column">
      {day.map((el, i) => (
        <WorkingTimeItem
          timeMenu={timeMenu}
          removeTime={removeTime}
          addTime={addTime}
          copyDay={copyDay}
          changeTime={changeTime}
          key={el}
          label={el}
          time={chooseTime(el)}
          intersection={getIntersectionRatio(el)}
        />
      ))}
    </Flex>
  );
}
